import { Planting ,SelectCropAndPlantingInShippingRecord} from '@/types/Component';
import moment from 'moment';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Modal from "@/assets/common/Modal/Modal.vue";
import { toCamel } from 'snake-camel';

type PreSelectItem = {
    plantingId: string,
    cropId: string
};

type SelectPlanting = {
    id: string | null,
    name: string
};

type SelectCropping ={
    id:string,
    name:string,
    phonetic : string
}

@Component({
    components: { Modal }
})
export default class SelectPlantingCollectiveShipping extends Vue {
    @Prop()
    private value?: boolean;

    @Emit('input')
    input(value: boolean): void {
        value
    }

    @Prop()
    private preSelectItem?: PreSelectItem;

    @Prop()
    private workDate?: Date;

    @Prop()
    private showSelectFrom?: boolean;

    @Prop()
    private isCropSelected?:boolean

    @Emit('selectedItem')
    selectedItem(): SelectCropAndPlantingInShippingRecord {
        return { crop:this.selectedCropping , planting: this.selectedPlanting };
    }

    private outOfTerm = false;
    private completeDisabled = true
    private searchWord = '';
    private plantings: Array<Planting> = [];
    private filteredPlantings: Array<Planting> = [];
    private displayPlantings: Array<Planting> = [];
    private fromPlantingList: Partial<Record<string, Array<Planting>>> = {};
    private selectedCrop = 'すべて';
    private selectedPlanting: SelectPlanting = { id: '', name: '' };
    private selectedCropping : SelectCropping = {id:'', name :'' , phonetic: ''};
    private selectedField = { id: '', name: '', plantedArea: 0 };
    private preSelectedPlanting = { id: '', name: '' };
    private preSelectedCropping = { id: '', name: '', phonetic:0 };

    private preSelectedCrop = { id: '', name: '' };
    private sortByPlantingFlag = 1;
    private sortByTermFlag = 1;

    @Watch('value')
    async whenOpen(): Promise<void> {
        if (this.value) {
            if(this.preSelectItem?.cropId && !this.isCropSelected){
                    const res = toCamel(await this.$apiClient.doRequest('get', `/plantings/${this.preSelectItem?.cropId}/null`)) as { plantings: Planting[] };
                    this.plantings = res.plantings; 
            }
            else{
                const res = toCamel(await this.$apiClient.doRequest('get', '/plantings')) as { plantings: Planting[] }
                this.plantings = res.plantings
            }
            const filterByPlanting = this.plantings.filter((p: Planting) => {
                return this.isWithinTheTerm(p.workStartDate, p.workEndDate);
            })
            this.filteredPlantings = filterByPlanting;
            this.selectedCrop = 'すべて';

            // Handle pre-selected item
            if (this.preSelectItem?.plantingId) {
                const { plantingId } = this.preSelectItem;
                const outOfTermOrIsHidden = !this.filteredPlantings.some(p => p.id === plantingId);
                const planting = outOfTermOrIsHidden ? this.plantings.find(p => p.id === plantingId) : this.filteredPlantings.find(p => p.id === plantingId);
                if (planting) {
                    this.selectedPlanting = this.preSelectedPlanting = { id: planting.id, name: planting.name };
                } else if (this.filteredPlantings.length > 0) {
                    this.filteringPlanting();
                } else {
                    this.selectedPlanting = this.preSelectedPlanting = { id: '', name: '' };
                }

                this.outOfTerm = !(
                    !outOfTermOrIsHidden ||
                    planting === undefined ||
                    this.filteredPlantings.some(p => p.id === plantingId) 
                );

                this.filteringPlanting();
            } else {
                const outOfTermOrIsHidden = !this.filteredPlantings.some(p => p.crop.id === this.preSelectItem?.cropId);
                const planting = outOfTermOrIsHidden ? this.plantings.find(p => p.crop.id === this.preSelectItem?.cropId) : this.filteredPlantings.find(p => p.crop.id === this.preSelectItem?.cropId);
                this.outOfTerm = !(
                    !outOfTermOrIsHidden ||
                    planting === undefined ||
                    this.filteredPlantings.some(p => p.crop.id === this.preSelectItem?.cropId) 
                );
                this.filteringPlanting();
            }
        } else {
            // Reset the modal when closed
            this.resetSelectItem();
        }
    }

    private resetSelectItem() {
        this.selectedCrop = 'すべて';
        this.selectedField = { id: '', name: '', plantedArea: 0 };
        this.selectedPlanting = { id: '', name: '' };
        this.preSelectedPlanting = { id: '', name: '' };
        this.outOfTerm = false;
        this.displayPlantings = [];
        this.searchWord = '';
        this.completeDisabled = true
    }

    private isWithinTheTerm(start: Date | null | undefined, end: Date | null | undefined) {
        const workDate = moment(this.workDate);
        const startDate = moment(start);
        const endDate = moment(end);
        return (!startDate.isValid() || workDate.isSameOrAfter(startDate)) && (!endDate.isValid() || workDate.isSameOrBefore(endDate));
    }

    private groupByCrop(plantings: Array<Planting>) {
        return plantings.reduce((group, p) => {
            if (!group[p.crop.name]) {
                group[p.crop.name] = [];
            }
            group[p.crop.name]?.push(p);
            return group;
        }, {} as Partial<Record<string, Array<Planting>>>);
    }

    private formatWorkDate(date: Date) {
        return moment(date).format('YYYY年M月D日');
    }

    private selectCrop(key: string) {
        this.selectedCrop = key;
        if(this.selectedCrop){
        const currentCrop = this.plantings.find(item=> item.crop.name === this.selectedCrop)?.crop
        this.selectedCropping = {id : currentCrop?.id ||"" , name : currentCrop?.name ||"", phonetic :currentCrop?.phonetic ||""}
        }
        this.selectPlanting(null,"作付を指定しない")
    }

    private selectPlanting(id: string | null, name: string) {
        const processedId = id ?? null;
        const processedName = name ?? '作付を指定しない';
        this.completeDisabled = false
        this.selectedPlanting = { id :processedId , name :processedName};
        if(!this.selectedPlanting.id){
            const currentCrop = this.plantings.find(item=> item.crop.name === this.selectedCrop)?.crop
            this.selectedCropping = {id : currentCrop?.id ||"" , name : currentCrop?.name ||"", phonetic :currentCrop?.phonetic ||""}
        }
        else{
        const selectedCropping = this.displayPlantings.find(item => item.id === this.selectedPlanting.id);
        this.selectedCropping = selectedCropping?.crop || { id: '', name: '', phonetic: '' };
    }
}

    private checkedPlanting(id: string) {

        return this.selectedPlanting?.id === id ? 'checked' : '';
    }

    private filteringPlanting() {
        this.displayPlantings = this.outOfTerm ? this.plantings : this.filteredPlantings;
        this.displayPlantings = this.displayPlantings.filter(x => x.name.includes(this.searchWord));
        this.fromPlantingList = { 'すべて': this.displayPlantings, ...this.groupByCrop(this.displayPlantings) };
        if (!this.fromPlantingList[this.selectedCrop]) {
            this.selectedCrop ='すべて';
        }
        if(this.preSelectItem?.cropId){
            this.selectedCrop = this.plantings.find(planting => planting.crop.id === this.preSelectItem?.cropId)?.crop.name || '';
        }
        else{
            this.selectedCrop ='すべて';
        }
        if(this.preSelectItem?.plantingId !== '' && this.preSelectItem?.plantingId != null){
            this.selectPlanting(this.selectedPlanting.id ,this.selectedPlanting.name);
        }
        else{
            this.selectPlanting(null, '作付を指定しない')
        }
    }

    private sortPlantingsByName(plantings: Planting[] | undefined) {
        return plantings?.sort((a, b) => (a.name > b.name ? this.sortByPlantingFlag : -this.sortByPlantingFlag));
    }

    private sortByPlanting() {
        const notSpecified = '作付を指定しない'
        this.displayPlantings.sort((a, b) => a.name != notSpecified && b.name != notSpecified
            ? a.name > b.name
                ? this.sortByPlantingFlag
                : -this.sortByPlantingFlag
            : -1
        )
        this.sortByPlantingFlag = -this.sortByPlantingFlag
    }

    private sortPlantingsByTerm(plantings: Planting[] | undefined) {
        return plantings?.sort((a, b) =>
            moment(a.workStartDate).isValid() && moment(b.workStartDate).isValid()
                ? moment(a.workStartDate).isSameOrBefore(moment(b.workStartDate))
                    ? this.sortByTermFlag
                    : -this.sortByTermFlag
                : 1
        );
    }

    private sortByTerm() {
        this.sortPlantingsByTerm(this.displayPlantings);
        if (this.selectedCrop) {
            this.sortPlantingsByTerm(this.fromPlantingList[this.selectedCrop]);
        }
        this.sortByTermFlag = -this.sortByTermFlag;
    }

    private cancel() {
        this.input(false);
    }

    get isModalVisible(): boolean {
        return this.value || false;
    }

    set isModalVisible(value: boolean) {
        this.input(value);
    }
}
